<p-dialog
    [(visible)]="visible"
    [header]="'service.settings.general.waitingList.label' | translate"
    [baseZIndex]="2000"
>
    <div class="input-grid-gaps grid-3col_auto gap">
        <app-date-input [form]="form" id="dateFrom"
            label="service.settings.general.waitingList.fields.dateFrom"
        ></app-date-input>
        <app-date-input [form]="form" id="dateTo"
            label="service.settings.general.waitingList.fields.dateTo"
        ></app-date-input>
        <app-text-input [form]="form" id="name"
            label="service.settings.general.waitingList.fields.name"
        ></app-text-input>
        <app-select-input
            id="type"
            [form]="form"
            label="service.settings.general.waitingList.fields.type"
            [staticOptions]="serviceWaitingListUnitEnumOptions"
            valueKey="value">
        </app-select-input>
        <app-text-input [form]="form" id="description" class="fr-2"
            label="service.settings.general.waitingList.fields.description"
        ></app-text-input>
        <app-check-input [form]="form" id="required"
            label="service.settings.general.waitingList.fields.required"
        ></app-check-input>
    </div>

    <ng-template #footer>
        <app-action-buttons (primaryClickEvent)="submit()" (secondaryClickEvent)="show(false)"></app-action-buttons>
    </ng-template>
</p-dialog>
